var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { create } from "zustand";
export const useDashboard = create((set, get) => ({
    id: undefined,
    loading: false,
    refreshing: false,
    dashboard: undefined,
    widgets: [],
    datasources: [],
    unauthorized: false,
    tab: 0,
    setTab: (tab) => set({ tab }),
    setId: (id, backend) => {
        let loading = get().loading;
        set({ id, loading: true });
        backend.datasources.list({ dashboard: id }).then(ds => {
            set({ datasources: ds });
        });
        backend.dashboards.get(id).then((dash) => {
            var _a;
            set({
                dashboard: dash,
                loading: false,
            });
            const interval = ((_a = dash.settings) === null || _a === void 0 ? void 0 : _a.cache_refresh_interval) || 5;
            const nextUpdate = new Date(dash.last_updated_at).getTime() + (interval * 60000);
            if (!loading &&
                nextUpdate < new Date().getTime()) {
                set({ refreshing: true });
                backend === null || backend === void 0 ? void 0 : backend.dashboard(id).updateWidgetCache().then((data) => {
                    backend;
                    let id = get().id;
                    if (id === data[0].dashboard) {
                        backend.widgets.list({ dashboard: id }).then((wid) => {
                            set({ widgets: wid });
                        });
                        set({
                            loading: false,
                            refreshing: false,
                            dashboard: Object.assign(Object.assign({}, dash), { last_updated_at: new Date().toISOString() }),
                        });
                    }
                    else {
                        set({
                            loading: false,
                            refreshing: false,
                        });
                    }
                });
            }
        }).catch((e) => {
            if (e.message === "Your subscription is not active") {
                set({ unauthorized: true });
            }
        });
    },
    setDashboard: (dashboard) => set({ dashboard }),
    setWidgets: (widgets) => set({ widgets }),
    refreshWidgets: (backend, widgetId) => __awaiter(void 0, void 0, void 0, function* () {
        let id = get().id;
        if (!id)
            return;
        if (widgetId) {
            let widgets = get().widgets;
            backend.widgets.get(widgetId).then((wid) => {
                set({
                    widgets: widgets.map((w) => {
                        if (w.id === wid.id) {
                            return wid;
                        }
                        return w;
                    })
                });
            });
        }
        else {
            backend.widgets.list({ dashboard: id }).then((wid) => {
                set({ widgets: wid });
            });
        }
    })
}));
//# sourceMappingURL=useDashboard.js.map